'use client'; // Error components must be Client Components

import ErrorComponent from '@/components/layout/error/ErrorComponent';

export default function Error() {
    return <ErrorComponent />;
}
